import { Form, Popup } from 'antd-mobile';
import { useEffect, useState } from 'react';
import s from './index.module.scss';
import { cloneDeep } from 'lodash';
import { getRules } from './util';
import { RightOutline } from 'antd-mobile-icons';

import ImageRender from '@/components/GrtImage/ImageRender';
const MultipleSelect = (props) => {
    let { updated, desc, formInstance, options, formDisabled } = props;
    const disabled = formDisabled === undefined ? updated !== 0 : formDisabled;
    const [multipleVisible, setMultipleVisible] = useState(false);
    const [selectedValue, setSelectedValue] = useState([]);
    useEffect(() => {
        let select_data = formInstance.getFieldValue(props.en_name);
        if (select_data) {
            setSelectedValue(select_data);
        }
    }, [multipleVisible]);
    const isSelected = (v) => {
        if (selectedValue.includes(v.id)) {
            return true;
        }
        return false;
    };
    const confireSelect = () => {
        formInstance.setFieldsValue({
            [props.en_name]: selectedValue
        });
        setMultipleVisible(false);
    };
    const open = () => {
        if (!disabled) {
            setMultipleVisible(true);
        }
        return false;
    };
    const selectItem = (v) => {
        let data = cloneDeep(selectedValue);
        let idx = data.indexOf(v.id);
        if (idx === -1) {
            data.push(v.id);
        } else {
            data.splice(idx, 1);
        }
        setSelectedValue(data);
    };
    const renderOptionItem = () => {
        return options.map((v, i) => {
            return (
                <div className={`${s['item']} ${isSelected(v) ? s['selected'] : ''}`} key={i} onClick={() => selectItem(v)}>
                    <div className={s['item-name']}>{v.name || '-'}</div>
                    {isSelected(v) ? (
                        <div className={s['item-status-icon']}>
                            <ImageRender src={require('@/assets/images/dynamicForm/checked.webp')} />
                        </div>
                    ) : null}
                </div>
            );
        });
    };
    const onCancel = () => {
        setSelectedValue([]);
        setMultipleVisible(false);
    };
    const deleteSelectData = (v) => {
        let select_data = formInstance.getFieldValue(props.en_name);
        let data = cloneDeep(select_data);
        let idx = data.indexOf(v);
        if (idx > -1) {
            data.splice(idx, 1);
            formInstance.setFieldsValue({
                [props.en_name]: data
            });
        }
        setSelectedValue(data);
    };
    const selectedItemShow = () => {
        let select_data = formInstance.getFieldValue(props.en_name);
        return (
            select_data?.length > 0 &&
            select_data.map((ele, i) => {
                let item = options.filter((v) => v.id === ele);
                let name = item.map((v) => v.name);
                return (
                    <div className={s['multipleShow']} key={i}>
                        <div className={s['name']}>
                            <span className="ellipsis">{name?.toString() || '-'}</span>
                        </div>
                        {!disabled && (
                            <div
                                className={s['delete']}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    deleteSelectData(ele);
                                }}
                            >
                                <ImageRender src={require('@/assets/images/dynamicForm/delete_icon.webp')} />
                            </div>
                        )}
                    </div>
                );
            })
        );
    };
    return (
        <>
            <Form.Item
                label={props.label === undefined ? props.name : props.label}
                name={props.en_name}
                rules={getRules(props)}
                layout={'horizontal'}
                childElementPosition={'right'}
                style={{
                    height: '100%'
                }}
            >
                {selectedValue?.length > 0 ? (
                    <span className={s['empty_wrap_choose']} onClick={open}></span>
                ) : (
                    <div
                        className={`${s['dynamic-cascade-item']} ${formInstance.getFieldValue(props.en_name)?.length > 0 ? s['visible'] : ''}`}
                        onClick={open}
                    >
                        <div className={s['desc']}>
                            <span className={s['txt']}>{desc || '请选择'}</span>
                            <span>
                                <RightOutline fontSize={12} color="#999999" style={{ marginLeft: 8 }} />
                            </span>
                        </div>
                    </div>
                )}
                {multipleVisible ? (
                    <Popup
                        visible={multipleVisible}
                        onMaskClick={onCancel}
                        className={s['multiple-popup']}
                        destroyOnClose={true}
                        bodyStyle={{ borderTopLeftRadius: '16px', borderTopRightRadius: '15px' }}
                    >
                        <div className={s['popup-content']}>
                            <div className={s['header']}>
                                <div className={s['cancel']} onClick={onCancel}>
                                    取消
                                </div>
                                <div className={s['comfire']} onClick={confireSelect}>
                                    确定
                                </div>
                            </div>
                            <div className={s['options-content']}>{renderOptionItem()}</div>
                        </div>
                    </Popup>
                ) : null}
            </Form.Item>
            <div className={s['reverse-show-wrap']} onClick={open}>
                {selectedItemShow()}
            </div>
        </>
    );
};
export default MultipleSelect;
